<template>
  <ChannelHeaderActionsProvider
    v-if="accountType === 'sitter'"
    :corresponding-user-account-id="correspondingUserAccountId"
    :current-channel-url="currentChannelUrl"
  />
  <ChannelHeaderActionsSeeker
    v-else
    :corresponding-user-account-id="correspondingUserAccountId"
    :corresponding-user-id="correspondingUserId"
    :current-channel-url="currentChannelUrl"
  />
</template>

<script lang="ts">
import ChannelHeaderActionsProvider from '@/apps/messages/components/channelHeader/ChannelHeaderActionsProvider.vue';
import ChannelHeaderActionsSeeker from '@/apps/messages/components/channelHeader/ChannelHeaderActionsSeeker.vue';

export default {
  name: 'ChannelHeaderActions',
  components: {
    ChannelHeaderActionsProvider,
    ChannelHeaderActionsSeeker,
  },
  props: {
    correspondingUserAccountId: {
      type: String,
      default: '',
    },
    correspondingUserId: {
      type: String,
      default: '',
    },
    accountType: {
      type: String,
      required: true,
    },
    currentChannelUrl: {
      type: String,
      default: '',
    },
  },
};
</script>
